import { PALETA_ATENDENTES, type CorAtendente } from '@viniko/shared';
import { useSyncExternalStore } from 'react';

type Escolha = 'claro' | 'escuro' | 'sistema';
const CHAVE = 'viniko.tema';
const midia = window.matchMedia('(prefers-color-scheme: dark)');
const ouvintes = new Set<() => void>();

function lerEscolha(): Escolha {
  try {
    const v = localStorage.getItem(CHAVE);
    return v === 'claro' || v === 'escuro' ? v : 'sistema';
  } catch {
    return 'sistema';
  }
}

function aplicar() {
  const e = lerEscolha();
  const raiz = document.documentElement;
  if (e === 'sistema') raiz.removeAttribute('data-theme');
  else raiz.setAttribute('data-theme', e === 'escuro' ? 'dark' : 'light');
  ouvintes.forEach((cb) => cb());
}

midia.addEventListener('change', aplicar);
aplicar();

export function ehEscuro(): boolean {
  const e = lerEscolha();
  return e === 'escuro' || (e === 'sistema' && midia.matches);
}

export function alternarTema() {
  try {
    localStorage.setItem(CHAVE, ehEscuro() ? 'claro' : 'escuro');
  } catch {}
  aplicar();
}

export function useTemaEscuro(): boolean {
  return useSyncExternalStore((cb) => {
    ouvintes.add(cb);
    return () => ouvintes.delete(cb);
  }, ehEscuro);
}

export function useCorAtendente(cor: CorAtendente | undefined) {
  const escuro = useTemaEscuro();
  const p = PALETA_ATENDENTES[cor ?? 'grafite'];
  return escuro ? p.escuro : p.claro;
}
